import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card h100" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge--color1" }, " Area #1 ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge--color2" }, " Area #2 ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge--color3" }, " Area #3 ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge--color4" }, " Area #4 ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge--color5" }, " Area #5 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('admin_kpi.zones_title')), 1),
    _createVNode(_component_DataTable, {
      loading: _ctx.isLoading,
      value: _ctx.value,
      scrollable: true,
      scrollHeight: "400px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "zone_name",
          header: "Città"
        }, {
          body: _withCtx(({data}) => [
            (_ctx.isTMT)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { name: _ctx.zoneRouteName, params: { zoneId: data.zone_id } },
                  class: "dark-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.zone_name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(data.zone_name), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          "body-class": "p-jc-center",
          field: "shape1_orders_count",
          style: {"min-width":"8rem"}
        }, {
          header: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          "body-class": "p-jc-center",
          field: "shape2_orders_count",
          style: {"min-width":"8rem"}
        }, {
          header: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          "body-class": "p-jc-center",
          field: "shape3_orders_count",
          style: {"min-width":"8rem"}
        }, {
          header: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          "body-class": "p-jc-center",
          field: "shape4_orders_count",
          style: {"min-width":"8rem"}
        }, {
          header: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          "body-class": "p-jc-center",
          field: "shape5_orders_count",
          style: {"min-width":"8rem"}
        }, {
          header: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "total",
          header: "Totale"
        })
      ]),
      _: 1
    }, 8, ["loading", "value"])
  ]))
}